import 'slick-carousel';

$( function() {
    heroSlider();
});

function heroSlider() { 

    $('.hero-slider').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        arrows: false,
        autoplay: true, 
    }); 
}
